export default "__VITE_PUBLIC_ASSET__cbd1e3e9__"